function splitTime(data, datetimeField, dateField, timeField) {
    if (data[datetimeField] && data[datetimeField].length > 0) {
        const time = data[datetimeField].split(" ")
        data[dateField] = time[0];
        data[timeField] = time[1];
    }
}

function mergeTime(data, datetimeField, dateField, timeField) {
    let result = ""
    if (data[dateField]) {
        result = data[dateField]

        if (data[timeField]) {
            result = `${data[dateField]} ${data[timeField]}`;
        }
    }

    data[datetimeField] = result
}

function loadTimeFields(data) {
    if (data) {
        splitTime(data, 'submitting_start', 'submitting_start', 'submitting_start_time')
        splitTime(data, 'submitting_end', 'submitting_end', 'submitting_end_time')
        splitTime(data, 'price_offer_date_start', 'price_offer_date_start', 'price_offer_date_start_time')
        splitTime(data, 'price_offer_date_end', 'price_offer_date_end', 'price_offer_date_end_time')
        splitTime(data, 'datetime_requests_processing', 'date_requests_processing', 'time_requests_processing')
        splitTime(data, 'datetime_sign_winner', 'date_sign_winner', 'time_sign_winner')
    }
}

function saveTimeFields(data) {
    if (data) {
        mergeTime(data, 'submitting_start', 'submitting_start', 'submitting_start_time')
        mergeTime(data, 'submitting_end', 'submitting_end', 'submitting_end_time')
        mergeTime(data, 'price_offer_date_start', 'price_offer_date_start', 'price_offer_date_start_time')
        mergeTime(data, 'price_offer_date_end', 'price_offer_date_end', 'price_offer_date_end_time')
        mergeTime(data, 'datetime_requests_processing', 'date_requests_processing', 'time_requests_processing')
        mergeTime(data, 'datetime_sign_winner', 'date_sign_winner', 'time_sign_winner')
    }
}

function calcSumFromPercent(sum, percent) {
    return Math.floor(sum * percent) / 100;
}

function calcPercentFromSum(sum, percent) {
    if (!sum) {
        return 0;
    }
    return Math.round((percent / sum) * 100 * 100) / 100;
}

export {
    splitTime,
    loadTimeFields,
    mergeTime,
    saveTimeFields,
    calcSumFromPercent,
    calcPercentFromSum,
}
